module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon27.18942cf4.png";